import { View } from "react-native";
import { useSheets } from "../data/useSheets";
import { DocumentReference } from "@atgof-firebase/firebase";
import FieldsRow from "./fields/FieldsRow";
import { useFieldSpecs } from "../data/useFieldSpecs";

export default function PASceneInfo({
  scene,
}: {
  scene: DocumentReference | undefined;
}) {
  const artsSheets = useSheets(scene, ["arts"]);
  const fieldSpecs = useFieldSpecs();
  if (!scene) return null;
  return (
    <View>
      {artsSheets?.map((sheet) => (
        <FieldsRow
          key={sheet.id}
          category="arts"
          readonly
          doc={sheet}
          fields={fieldSpecs.arts.arts}
        />
      ))}
    </View>
  );
}
